import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import { Box, Typography } from '@material-ui/core';


export default function IconLabel(props) {

  const useStyles = makeStyles((theme) => ({
    root: props.centered ? {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: props.spacing || 0,
      paddingRight: props.spacing || 0,
      marginTop: props.mt || 0,
      marginBottom: props.mb || 0
    } : {
        display: "flex",
        alignItems: "center",
        paddingLeft: props.spacing || 0,
        paddingRight: props.spacing || 0,
        marginTop: props.mt || 0,
        marginBottom: props.mb || 0
      },
  }));

  const classes = useStyles(props);
  
  let labelText = (props.label) ? props.label : props.children;
  const linkPos = labelText.indexOf("{0}");
  let left = labelText;
  let right = "";
  if (linkPos >= 0) {
    left = labelText.substring(0, linkPos);
    right = labelText.substring(linkPos + 3);
  } 


  return (
    <div className={classes.root}>
      {props.type == "error" && <ErrorOutlineIcon style={{ color: "red" }} />}
      {props.type == "warning" && <ErrorOutlineIcon style={{ color: "orange" }} />}
      {props.type == "check" && <CheckCircleOutlineIcon style={{ color: "green" }} />}
      {props.type == "info" && <InfoOutlinedIcon style={{ color: "#0D4A81" }} />}
      {props.type == "paused" && <PauseCircleOutlineIcon style={{ color: "#0D4A81" }} />}
      {props.icon}
      {!props.icon && !props.type && <InfoOutlinedIcon style={{ color: "#0D4A81" }} />}
      <Typography variant="body1" color="primary" style={{ paddingTop: 3, paddingLeft: 10 }}>{left}{props.link}{right}</Typography>
    </div>
  );
}
